import { render, staticRenderFns } from "./TumKategoriler.vue?vue&type=template&id=c743fe52&"
import script from "./TumKategoriler.vue?vue&type=script&lang=js&"
export * from "./TumKategoriler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports